<button mat-button class="quick-links-trigger" [matMenuTriggerFor]="shortcuts">
  <mat-icon>bolt</mat-icon><span>Quick Actions</span>
</button>
<mat-menu #shortcuts="matMenu" xPosition="after">
  <div class="shortcuts-heading">QUICK ACTIONS</div>
  <button mat-menu-item *ngFor="let link of userQuickLinks" (click)="selectComponent(link)">
    <mat-icon>{{ link.icon }}</mat-icon>
    <span class="shortcut-copy"><strong>{{ link.label }}</strong><small>{{ link.description }}</small></span>
  </button>
</mat-menu>
<ng-template #actionPanel>
  <div class="action-panel">
    <div class="action-toolbar"><span>Quick Actions / {{ selectedLabel }}</span><button mat-icon-button (click)="closeQuickLink()" aria-label="Close quick link"><mat-icon>close</mat-icon></button></div>
    <div class="action-content"><ng-container *ngComponentOutlet="selectedComponent"></ng-container></div>
  </div>
</ng-template>
